import React, { useState } from 'react';
import { Carousel } from "antd";
import { Link } from "react-router-dom";

import { url } from "../../inv";

export default function HomeSlider({ homeAlbum, windowWidth }) {
  let height = "80vh";
  if (windowWidth < 960) {
    height = "60vh";
  } else if ( windowWidth < 760) {
    height = "40vh"
  }

  const sliderHandler = () => {
    if (homeAlbum && homeAlbum.length > 0) {
      return homeAlbum.map((h, i) => {
        if (i > 2 ) return;
        return (
          <li key={i}>
            <div style={{ position: "absolute", zIndex: 1, left: 0 }}></div>
            <div style={{ margin: "auto", position: "relative", marginBottom: -6 }}>
              <div style={{ width: "100%", overflow: "hidden",
                  height: height,  display: "flex", justifyContent: "center", alignItems: "center"
                }}>
                <img style={{height: height}} src={`${url}/public/${h.fileNames[0]}`}/>
                {/* <img src={`${url}/public/${h.fileNames[0]}`}/> */}
              </div>
              
              <div className={"home-album-content"}>
                <Link to={`/detail?${h.postId}`} className="home-album-content-sub-title">
                  <label>{h.data.value.title}</label>
                </Link>
                <Link to="/" className="home-album-content-title">
                  <h1 className={"home-albume-title"}>
                    <label>{h.data.value.subTitle}</label>
                  </h1>
                </Link>
              {/* <label>{h.data.value.details[0]}</label> */}
              </div>
            </div>
          </li>
        );
      });
    } else {
      return "";
    }
  }

  return(
    <div>
      <Carousel autoplay autoplaySpeed={3500} next={() => {}}>
        {sliderHandler()}
      </Carousel>
    </div>
  );
}


{/* <div style={{
  position: "relative",
  backgroundImage: `url(${home1})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  minHeight: "80vh",
  display: 'flex',
  justifyContent: 'center',
  }}>
  <div className={"home-album-content"}>
    <Link to="/" className="home-album-content-sub-title">
      <label>Detail ..</label>
    </Link>
    <Link to="/" className="home-album-content-title">
      <h1 style={{color: "white", fontSize: "56px"}}>Khan alFan forever!</h1>
    </Link>
  </div>
</div> */}